import App from "@/App";
import Loader from "@/components/Loader";
import { Toaster } from "@/components/ui/toaster";
import "@/index.css";
import { persistor, store } from "@/store/store";
import "@fontsource/poppins";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import * as Sentry from "@sentry/react";


Sentry.init({
  dsn: "https://08af42b178dcccde8e20bcd0513a4d84@o4509706001580032.ingest.us.sentry.io/4509706004398080",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  // integrations: [Sentry.browserTracingIntegration()],
  // tracesSampleRate: 1.0,
  sendDefaultPii: true,
  // tracePropagationTargets: ["localhost", "ethical-ladybird-kindly.ngrok-free.app","studio.dev.imprintmaker.com","imprintmaker.com" ,"app.imprintmaker.com"],
});

createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <PersistGate loading={<Loader />} persistor={persistor}>
      <App />
      <Toaster />
    </PersistGate>
  </Provider>,
);
